import React from 'react';
import { useRouter } from 'next/router';

import { BeehiivPublicationIds, BeehiivPublicationTitles } from '@blockworks/platform/api/beehiiv';
import { FlexBox, MailOutlineIcon, Text } from '@blockworks/ui';
import { Form } from '@blockworks/ui/forms/form';
import { toast } from '@blockworks/ui/toast';

import { beehiivMutations } from '@/api/beehiiv/beehiiv.mutations';

import { newsletterSignupSchema } from '../auth/forms/newsletter-signup.schema';

interface NewsletterSignupSectionProps {
    publicationTitle: BeehiivPublicationTitles;
    campaign: string;
    source: string;
    publication: BeehiivPublicationIds;
    stacked?: boolean;
}

const NewsletterSignupSection = ({
    publicationTitle,
    campaign,
    source,
    publication,
    stacked,
}: NewsletterSignupSectionProps) => {
    const router = useRouter();
    const { control } = Form.use({
        values: { email: '' },
        resolver: Form.resolvers.yup(newsletterSignupSchema),
    });
    const newsletterSignup = beehiivMutations.useSubscribeToPublication.use({
        onSuccess: () => {
            toast.success('Successfully subscribed to the newsletter.');
            control._reset();
        },
        onError: () => {
            toast.danger('Error subscribing to the newsletter.');
        },
    });

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        newsletterSignup.mutate({
            email: e.currentTarget.email.value as string,
            sourcePath: router.asPath,
            source,
            campaign,
            publication,
            medium: 'organic',
        });
    };

    return (
        <Form onSubmit={handleSubmit}>
            <FlexBox gap="md" col mb={2}>
                <Text size="md" weight="bold">
                    {`Subscribe to ${publicationTitle} Newsletter`}
                </Text>
                <FlexBox
                    gap="md"
                    w="full"
                    alignItems={{ initial: 'start', sm: stacked ? 'start' : 'center' }}
                    direction={{ initial: 'col', sm: stacked ? 'col' : 'row' }}
                >
                    <Form.Input
                        id="name"
                        name="email"
                        required
                        variant="outline-fill"
                        control={control}
                        placeholder="Enter your email address"
                        icon={MailOutlineIcon}
                        tooltipText={`Alpha directly in your inbox, including market highlights, charts, degen trade ideas, governance updates, token performance, can't-miss-tweets and more, by Blockworks Research.`}
                    />
                    <Form.Submit
                        intent="muted"
                        variant="fill"
                        disabled={newsletterSignup.isPending}
                        borderRadius="md"
                        alignSelf={'start'}
                        type="submit"
                    >{`Subscribe`}</Form.Submit>
                </FlexBox>
            </FlexBox>
        </Form>
    );
};

export default NewsletterSignupSection;
